var modules_51430e0a = {"container":"_t6b0xg","searchContainer":"_19hjbrs"};
import "../../assets/CcDneRWs.css";

export { modules_51430e0a as default };
//# sourceMappingURL=MenuItem.module.less.js.map
